<div class="safe-area ">
  <h3 class="title">{{ "Review Your Resume" | translate }}</h3>
  <div class="row mx-2 mx-lg-5 ">
    <div class="col-12 col-md-5 col-lg-4 order-2 order-md-1">
      <h5 class="title">{{ "Download" | translate }}</h5>
      <ng-container>
        <div *ngIf="!isPdfPurchased">
          <div class="row pdf" (click)="goToPayment('generate-cv-pdf')">
            <p class="col m-0 d-flex align-items-center justify-content-center">
              <img src="./assets/icon/pdf.png" />
              <span>{{ "Purchase PDF" | translate }}</span>
            </p>
            <p class="price col-auto">100 LE</p>
          </div>
        </div>
        <div *ngIf="!isWordPurchased && !isPdfPurchased" class="mt-3">
          <div class="row word" (click)="goToPayment('generate-cv-word')">
            <p class="col m-0 text-center d-flex align-items-center justify-content-center">
              <img src="./assets/icon/pdf.png" />
              <img src="./assets/icon/word.png" />
              <span class="px-1">{{ "Purchase PDF and Word" | translate }}</span>
            </p>
            <p class="price col-auto">150 LE</p>
          </div>
        </div>
      </ng-container>
      <ng-container>
        <div *ngIf="isPdfPurchased">
          <div class="row pdf" (click)="downloadFile(pdfPath)">
            <p class="col m-0 d-flex align-items-center justify-content-center">
              <img src="./assets/icon/pdf.png" />
              <span>{{ "Download PDF" | translate }}</span>
            </p>

          </div>
        </div>
        <div *ngIf="isWordPurchased " class="mt-3">
          <div class="row word" (click)="downloadFile(wordPath)">
            <p class="col m-0 text-center d-flex align-items-center justify-content-center">
              <img src="./assets/icon/pdf.png" />
              <img src="./assets/icon/word.png" />
              <span class="px-1">{{ "Download Word" | translate }}</span>
            </p>

          </div>
        </div>
      </ng-container>
    </div>

    <!-- Added protection wrapper -->
    <div class="col-12 col-md-7 col-lg-8 order-1 order-md-2 cv-preview-container"
      (contextmenu)="$event.preventDefault()">
      <img [src]="cvUrlImage" alt="Generated CV Preview" />
    </div>

  </div>
</div>
<div class="next-container px-4">
  <button class="border-button m-3" (click)="onPrevious()">
    {{ "Back" | translate }}
  </button>
</div>